import { useState, type FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9nfggkit35ii3jdlqn0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      const serverMsg = parsed?.meta?.message || parsed?.message || '';

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
        setTimeout(() => setStatus('idle'), 3000);
      } else {
        setStatus('error');
        setErrorMsg(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-primary-500">
      <div className="max-w-2xl mx-auto text-center">
        <i className="ri-mail-send-line text-4xl text-white/80 mb-4 inline-block"></i>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
          订阅更新通知
        </h2>
        <p className="text-white/80 text-sm mb-8 leading-relaxed">
          第一时间获取最新电视剧上线通知，不错过任何一部好剧。
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto" data-readdy-form>
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 w-full px-5 py-3.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white placeholder-white/50 text-sm focus:outline-none focus:border-white/40 focus:ring-2 focus:ring-white/10 transition-all"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-8 py-3.5 bg-white text-primary-600 rounded-full font-medium text-sm hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer disabled:opacity-60"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-white/90 text-sm">订阅成功！感谢您的关注。</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-white/90 text-sm">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}